import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Field } from 'src/app/models/field';
import { FileModel } from 'src/app/models/file';

@Component({
  selector: 'app-copy-widget',
  templateUrl: './copy-widget.component.html',
  styleUrls: ['./copy-widget.component.css']
})
export class CopyWidgetComponent implements OnInit {

  ngOnInit(): void {
   
      setTimeout(() => {
        console.log(this.myForm);
      }, 3000);


      this.field.ui.hidden=this.field.hidden;
      this.field.ui.editable=this.field.editable;
      this.field.ui.required=this.field.required;

  }

  @Input() myForm!: UntypedFormGroup;

  @Input()
  field!: Field;

  @Input()
  fieldId:string|undefined;

  @Input()
  yourTurn:boolean|undefined;

  @Input()
  submitted:boolean|undefined;

  @Input()
  control!: any;

  @Input()
  errors:any;

  @Input()
  isInvalid:boolean=false;


  @Input()
  isContainer:boolean=false;


  @Input()
  containerFieldId:string|undefined=undefined;

  @Input()
  fieldIndex:number|undefined=undefined;

  @Input()
  files:FileModel[]=[];


  @Output() 
  refreshFormEvent:EventEmitter<{fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean}>=new EventEmitter<{fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean}>();


  refreshForm(fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean){

    this.refreshFormEvent.emit({ fieldId ,shouldRefresh,containerFieldId,fieldIndex,isContainer});

  }

  
  getFiles(controlName:string):FileModel[]{
    return this.files.filter(x=>x.controlName==controlName);
  }

  getFormControlErrors(fieldId: string): ValidationErrors {
    const control = this.myForm?.get(fieldId);
    return control?.errors!;
  }

  getFormControlValidation(fieldId: string): boolean {
    const control = this.myForm?.get(fieldId);
    return control?.invalid!;
  }

}
